export default __webpack_public_path__ + "static/iam_role_03-00e4be69771bece0e8ba72f2cc4a1122.png";